<template>
    <div>
      <el-tabs v-model="tabName">
        <el-tab-pane label="贷款信息" name="summary">
          <financing-detail-component
            :financing-detail-data="financingDetailData"
            :repayment-plan-list="repaymentPlanList"
            :contract-data="contractData"
          ></financing-detail-component>
        </el-tab-pane>
        <el-tab-pane label="放款信息" name="pay" v-if="false">
          <el-form>
            <el-row>
              <el-col :span="6">
                <el-form-item label="贷款金额"></el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="实际放款日"></el-form-item>
              </el-col>
            </el-row>
          </el-form>
        </el-tab-pane>
        <el-tab-pane label="放款还款" name="RepayDetail">
          <repay-detail-data-table
            :repayment-plan-list="repaymentPlanList"
            :repayment-list="repaymentList"
            :pay-pledge-financing-data="payPledgeFinancingData"
            :is-can-repay="false"
            class="xzpadd10 bg-purple"
          />
        </el-tab-pane>
      </el-tabs>
    </div>
</template>

<script>
  import FinancingDetailComponent from './FinancingDetailComponent'
  import RepayDetailDataTable from './RepayDetailDataTable'

  export default {
    name: "FinancingViewComponent",
    data() {
      return {
        tabName: 'summary',
      }
    },
    props: {
      isCanRepay: {
        type: Boolean,
        default: true,
      },
      financingDetailData: {
        type: Object,
        default:()=>{
          return {}
        }
      },
      payPledgeFinancingData:{
        type: Object,
        default:()=>{
          return {}
        }
      },
      repaymentPlanList: {
        type: Object,
        default: ()=>{
          return {}
        }
      },
      repaymentList:  {
        type: Object,
        default: ()=>{
          return {}
        }
      },
      contractData: {
        type: Object,
        default:()=>{
          return {}
        }
      }
    },
    watch: {
      tabName: function (newVal) {
        this.$emit('get'+ newVal)
      }
    },
    components: {
      FinancingDetailComponent,
      RepayDetailDataTable
    },
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/components/FinancingViewComponent.vue